import { Button, Flex, Input, InputBase } from "@mantine/core"
import { useForm, UseFormReturnType } from "@mantine/form"
import CheveronDownIcon from "common/icons/cheveron-down"
import REGEX from "constants/regex"
import { FC } from "react"
import IProjectCreate from "rules/interface/project/create.interface"
import toEnglishDigits from "utils/persian-to-english-digit"




interface IProps {
    form: UseFormReturnType<IProjectCreate>
    nextStep: (e: IProjectCreate) => void
    prevStep: () => void
    loading?: boolean
}


const PriceFormStepUser: FC<IProps> = ({ form: projectForm, nextStep, prevStep, loading }) => {

    const form = useForm<IProjectCreate>({
        initialValues: {
            ...(projectForm.values?.user && {
                user: {
                    lastname: projectForm.values.user?.lastname,
                    phoneNumber: projectForm.values.user?.phoneNumber,
                }
            }),
            user: {
                lastname: "",
                phoneNumber: ""
            }
        },
        validate: {
            user: {
                lastname: value => !value && "نام و نام خانوادگی نمیتواند خالی باشد",
                phoneNumber: value => {
                    if (!value) return "شماره تماس نمیتواند خالی باشد"
                    if (!toEnglishDigits(value)?.match(REGEX.PHONE_NUMBER)) return "شماره‌تلفن صحیح وارد نمایید"
                },
            }
        }
    })

    const onSubmit = (values: IProjectCreate) => {

        values.user.phoneNumber = toEnglishDigits(values.user.phoneNumber)

        projectForm.setValues({
            ...projectForm.values,
            ...values
        })

        nextStep(values)
    }



    return (
        <form
            onSubmit={form.onSubmit(
                values => onSubmit(values),
                errors => {
                    const firstErrorPath = Object.keys(errors)[0];
                    form.getInputNode(firstErrorPath)?.focus();
                },
            )}
            className="w100"
        >
            <Flex
                direction="column"
                gap={32}
                w="100%"
            >
                <Flex
                    direction="column"
                    gap={18}
                >
                    <Input.Wrapper label="نام خانوادگی">
                        <InputBase
                            placeholder="نام خانوادگی خود را وارد کنید."
                            {...form.getInputProps('user.lastname')}
                        />
                    </Input.Wrapper>

                    <Input.Wrapper label="شماره تماس">
                        <InputBase
                            inputMode="tel"
                            placeholder="شماره تماس خود را وارد کنید."
                            {...form.getInputProps("user.phoneNumber")}
                        />
                    </Input.Wrapper>
                </Flex>

                <Flex direction={{ base: "column", sm: "row" }} align="center" justify="space-between" gap={8}>
                    <Button
                        rightSection={
                            <CheveronDownIcon
                                style={{ transform: "rotate(90deg)" }}
                                color="#fff"
                            />
                        }
                        loading={loading}
                        type="submit"
                        w="100%"
                    >
                        مرحله بعدی
                    </Button>

                    <Button
                        onClick={prevStep}
                        variant="outline"
                        loading={loading}
                        w="100%"
                    >
                        مرحله‌ی قبل
                    </Button>
                </Flex>
            </Flex>
        </form>
    )
}

export default PriceFormStepUser